module.exports = __webpack_public_path__ + "static/media/nest_placeholder.c5f0a323.jpg";